module.exports = require("./../../_gen/starling/filters/FragmentFilter");